import { render, staticRenderFns } from "./PreviewPDF.vue?vue&type=template&id=5d7b670a&"
import script from "./PreviewPDF.vue?vue&type=script&lang=js&"
export * from "./PreviewPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports